function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { nanoid } from 'nanoid';
import { TableUtils } from '@deephaven/jsapi-utils';
import Log from '@deephaven/log';

// [x,y] screen coordinates used by the Linker

export function isLinkableFromPanel(panel) {
  var p = panel;
  return typeof p.getCoordinateForColumn === 'function';
}
export function isLinkablePanel(panel) {
  var p = panel;
  return isLinkableFromPanel(panel) && typeof p.setFilterMap === 'function' && typeof p.unsetFilterValue === 'function';
}
export function isLinkableColumn(column) {
  // TODO: core/#3358 Use preview/original type property instead of checking description
  return column.description == null || !column.description.startsWith('Preview of type: ');
}
var log = Log.module('LinkerUtils');

/**
 * Collection of utility functions for use with the Linker
 */
class LinkerUtils {
  /**
   * Retrieve the type of link given parameters.
   * @param start The link start
   * @param end The link end
   * @param isolatedLinkerPanelId Whether there's an isolated linker
   * @returns The type of link, or invalid if there's an error
   */
  static isLinkValid(start, end, isolatedLinkerPanelId) {
    // Panel compatibility checks:
    // Link ends should point to different non-null panelIds
    // For isolated linker one of the panels should match isolated panel id
    if (start.panelId == null || end.panelId == null || start.panelId === end.panelId || isolatedLinkerPanelId != null && isolatedLinkerPanelId !== start.panelId && isolatedLinkerPanelId !== end.panelId) {
      log.debug2('Incompatible panel ids', start, end, isolatedLinkerPanelId);
      return false;
    }

    // Check column type compatibility
    var startColumnType = start.columnType;
    var endColumnType = end.columnType;

    // Null columnType in ending link point allows linking to any type
    var isCompatibleType = endColumnType === null || TableUtils.isCompatibleType(startColumnType, endColumnType);
    if (!isCompatibleType) {
      log.debug2('Incompatible type', startColumnType, endColumnType);
      return false;
    }
    return true;
  }

  /**
   * Find column matching the link point
   * @param columns Columns to search in
   * @param linkPoint Link point to find column for
   * @param linkPoint.columnName Column name to find
   * @param linkPoint.columnType Column type to find
   * @returns Column matching the link point, undefined if not found
   */
  static findColumn(columns, _ref) {
    var columnName = _ref.columnName,
      columnType = _ref.columnType;
    return columns.find(_ref2 => {
      var name = _ref2.name,
        type = _ref2.type;
      return name === columnName && type === columnType;
    });
  }

  /**
   * Clone links for a given panel id
   * @param links Original links array
   * @param panelId Original panel id
   * @param cloneId Cloned panel id
   * @returns Cloned links array or empty array if no new links added
   */
  static cloneLinksForPanel(links, panelId, cloneId) {
    var clonedLinks = [];
    links.forEach(link => {
      var _link$end;
      if (link.start.panelId === panelId && link.type !== 'filterSource') {
        clonedLinks.push(_objectSpread(_objectSpread({}, link), {}, {
          id: nanoid(),
          start: _objectSpread(_objectSpread({}, link.start), {}, {
            panelId: cloneId
          })
        }));
      } else if (((_link$end = link.end) === null || _link$end === void 0 ? void 0 : _link$end.panelId) === panelId) {
        clonedLinks.push(_objectSpread(_objectSpread({}, link), {}, {
          id: nanoid(),
          end: _objectSpread(_objectSpread({}, link.end), {}, {
            panelId: cloneId
          })
        }));
      }
    });
    return clonedLinks;
  }
}
export default LinkerUtils;
//# sourceMappingURL=LinkerUtils.js.map